<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card elevation="6" rounded="xl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h4 class="text-h6 font-weight-bold mb-0">
                Point - Track Enquiry Reward Points -
                {{
                  this.$route.params.positionId == 2
                    ? "MARKETING EXECUTIVE"
                    : this.$route.params.positionId == 3
                    ? "DRIVER"
                    : this.$route.params.positionId == 4
                    ? "TRANSPORTER"
                    : ""
                }}
              </h4>

              <v-btn
                v-if="trackProgresses.length > 0"
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                fab
                x-small
                color="primary"
                :to="`/enquiry-rewards/${this.$route.params.positionId}/edit`"
              >
                <v-icon dark> mdi-pencil </v-icon>
              </v-btn>
              <!-- <v-btn
                v-else
                class="mx-4 mb-2"
                fab
                x-small
                color="primary"
                to="/track-progresses/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn> -->
            </v-card-title>
          </v-card>
        </v-col>
        <v-col md="12">
          <v-card elevation="6" rounded="xl">
            <template v-if="trackProgresses && trackProgresses.length > 0">
              <v-timeline dense>
                <v-timeline-item
                  v-for="(level, index) in trackProgresses"
                  :key="index"
                  small
                  color="primary"
                  fill-dot
                >
                  <v-row>
                    <v-col cols="6">
                      <v-card
                        elevation="3"
                        class="pa-5"
                        color="grey lighten-4"
                        rounded="xl"
                      >
                        <!-- Header: Level -->
                        <div class="d-flex align-center mb-4">
                          <!-- <v-icon color="primary" class="mr-2"
                          >mdi-flag-checkered</v-icon
                        > -->
                          <h3 class="text-h6 font-weight-bold mb-0">
                            Level {{ index + 1 }}
                          </h3>
                        </div>

                        <!-- Points per Liter -->
                        <div
                          class="text-h5 font-weight-bold mb-2 text-primary text-center"
                        >
                          {{ level.given_points }} Points
                        </div>

                        <!-- Liter Range -->
                        <!-- <div class="text-subtitle-2 grey--text mb-3">
                        {{ level.min_liters }} L – {{ level.max_liters }} L
                      </div> -->

                        <!-- Optional Progress Bar -->
                        <v-progress-linear
                          :value="100"
                          height="16"
                          color="primary"
                          background-color="grey lighten-2"
                          rounded
                        >
                          <template #default>
                            <div
                              class="d-flex justify-space-between px-2 text-caption font-weight-medium"
                            >
                              <span>
                                {{ level.min_amount }} Rs -
                                {{ level.max_amount }} Rs
                              </span>
                            </div>
                          </template>
                        </v-progress-linear>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </template>
            <template v-else>
              <v-card-text>
                <div class="text-center mt-4">
                  <v-icon size="40" color="grey lighten-1">mdi-alert</v-icon>
                  <p class="text-subtitle-1 grey--text font-weight-medium">
                    No Point Track Progress Found
                  </p>
                  <v-btn
                    color="primary"
                    to="/track-success-points/create"
                    small
                  >
                    Add Track Progress
                  </v-btn>
                </div>
              </v-card-text>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "EnquiryRewardsPage2",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
      },
      trackProgresses: [],
      isLoading: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      console.log("positionId", this.$route.params.positionId);
      if (this.$route.params.positionId) {
        this.filter.position_id = this.decryptIt(this.$route.params.positionId);
      } else {
        this.filter.position_id = "";
      }
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&position_id=" +
        this.filter.position_id +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`enquiry_form_reward_points?${query}`)
        .then((response) => {
          this.trackProgresses = response.data.data;
          console.log(this.$route);
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
  },
};
</script>
